import { useEffect, useRef, useState } from 'react';

/**
 * 텍스트가 컨테이너보다 길 때 marquee 애니메이션을 적용하는 커스텀 훅
 * @param dependency - 텍스트가 변경될 때마다 애니메이션 여부를 재계산할 의존성
 * @returns { shouldAnimate, textRef, containerRef } - 애니메이션 여부와 필요한 ref들
 */
export const useMarqueeAnimation = (dependency?: string) => {
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const textRef = useRef<HTMLParagraphElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependency 의존성 추가
  useEffect(() => {
    if (textRef.current && containerRef.current) {
      const textWidth = textRef.current.scrollWidth;
      const containerWidth = containerRef.current.clientWidth;
      setShouldAnimate(textWidth > containerWidth);
    }
  }, [dependency]);

  return {
    shouldAnimate,
    textRef,
    containerRef
  };
};
